<section class="rs-es-first-section" *ngIf="selectedProduct">
  <mprd-back-link></mprd-back-link>
  <div class="row">
    <div class="columns small-12">
      <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit" data-cy="productDescription">
        {{ selectedProduct?.productDescription }}
      </h1>
      <p class="rs-txt-s5 rs-txt-c2 small-only-text-center" x-ms-format-detection="none">
        <mprd-access-number-formatter
          [accessNumber]="selectedProduct?.accessNumber"
          [plc]="selectedProduct?.plc"
        ></mprd-access-number-formatter>
      </p>

      <div class="panel rs-panel-big clearfix">
        <h2 class="rs-tit3">{{ optionName }}</h2>
        <p data-cy="optionDescription">{{ option?.description }}</p>

        <p class="small-only-text-center">
          <mprd-price
            [option]="option"
            (isIncludedOption)="isOptionIncluded($event)"
            amountClass="rs-price-m"
            [showPriceForIncluded]="isConfigurableOption"
            data-cy="productPrice"
          ></mprd-price>
        </p>
        <a *ngFor="let downloadLink of option?.downloadLinks" href="{{ downloadLink.webUrl }}"
          ><img
            alt="{{ downloadLink.os }}"
            [src]="getDownloadAppstoreImageByOs(downloadLink.os)"
            class="rs-margin-right1"
            target="_blank"
        /></a>
        <div>
          <a
            *ngIf="option?.configureLink?.url"
            href="{{ option?.configureLink?.url[languageService.getSelectedLanguage()] }}"
            target="_blank"
            class="rs-btn rs-btn-third"
          >
            {{ option?.configureLink?.label[languageService.getSelectedLanguage()] }}
            <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"
              ><span class="show-for-sr">{{
                'option.details.openWindow.accessibility' | translate
              }}</span></i
            >
          </a>
        </div>
        <div>
          <a
            *ngIf="
              option?.manageOptionLink &&
              [PlcCodes.MMI, PlcCodes.MMV].includes(selectedProduct?.plc)
            "
            href="{{ option?.manageOptionLink?.url[languageService.getSelectedLanguage()] }}"
            target="_blank"
            class="rs-btn rs-btn-third"
          >
            {{ option?.manageOptionLink?.label[languageService.getSelectedLanguage()] }}>
            <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
          </a>
        </div>
        <div>
          <a
            *ngIf="option?.redirectLink?.url"
            href="{{ buildRedirectURL() }}"
            target="_blank"
            class="rs-btn rs-btn-third"
          >
            {{ option?.redirectLink?.label[languageService.getSelectedLanguage()] }}
            <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
          </a>
        </div>
        <px-alert [alertKey]="'ebuOrderingAlert'"></px-alert>
        <px-alert data-cy="pxAlertBox" *ngIf="option" [alertKey]="getAlertKey()"></px-alert>
        <p class="small-only-text-center" *ngIf="isPayDateInFuture">
          {{ payDateInFutureText }}
        </p>
        <div
          *ngIf="hideCeaseButton"
          class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only"
        >
          <div class="rs-flex-columns">
            <mprd-ebu-order-button
              *ngIf="isEbuOrderingEnabled"
              [option]="option"
              [selectedProduct]="selectedProduct"
              [isPayDateInFuture]="isPayDateInFuture"
            ></mprd-ebu-order-button>
          </div>
          <div
            *ngIf="option && selectedProduct && isEbuOrderingEnabled"
            class="rs-flex-columns rs-flex-grow"
          >
            <p class="small-only-text-center" x-ms-format-detection="none">
              {{ 'option.details.for' | translate }}&nbsp;
              <mprd-access-number-formatter
                [accessNumber]="selectedProduct?.accessNumber"
                [plc]="selectedProduct?.plc?.toString()"
              ></mprd-access-number-formatter>
            </p>
          </div>
        </div>
        <div class="rs-flex-columns" *ngIf="option?.customTermsAndConditions">
          <p class="rs-padding-bottom1 rs-word-break-all">
            <a
              href="{{
                option.customTermsAndConditions.url[languageService.getSelectedLanguage()]
              }}"
              target="_blank"
              >{{ option.customTermsAndConditions.label[languageService.getSelectedLanguage()]
              }}<span class="rs-icon-link-tb" title="Opens a new window"
                ><span class="show-for-sr">{{
                  'products.option.details.customTermsAndCondition.accessibility' | translate
                }}</span></span
              ></a
            >
          </p>
        </div>
        <div class="rs-me2"></div>
        <div class="row collapse" *ngIf="option?.image">
          <img class="show-for-large-up" [src]="option.image?.large" />
          <img class="show-for-medium-only" [src]="option.image?.medium" />
          <img class="show-for-small-only" [src]="option.image?.small" />
        </div>
        <small *ngIf="!treatmentCode" class="rs-txt-s2 rs-block">{{
          'common.options.priceMention' | translate
        }}</small>
        <span id="footnotes" aria-hidden="true" tabindex="-1"></span>
        <h2 id="footnote-label" class="show-for-sr">
          {{ 'option.details.footNote.accessibility' | translate }}
        </h2>
      </div>
      <div class="ebu-debug" *ngIf="debugMode" [innerHTML]="debugLogs"></div>
    </div>
  </div>
  <div class="rs-le2"></div>
</section>
